/* eslint-disable no-console */
import React, { useEffect, useState, useCallback } from 'react';

import { toast } from 'react-hot-toast';
import { v4 } from 'uuid';

import { Col, Row } from 'reactstrap';

import { FaPlus, FaCheck } from 'react-icons/fa';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './TipCircle';

import api2 from '~/services/api2';

import { useAuth } from '~/context/AuthContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {
  Button,
  Divider,
  IconExchange,
  IconPencilFilled,
  IconTrashFilled,
  Spinner,
  Switch,
} from 'takeat-design-system-ui-kit';
import api from '~/services/api';
import { BRLCurrencyInput } from '~/components/BRLCurrencyInput';
import {
  Card,
  Map,
  PlusButton,
  AddressesTable,
  InputStyled,
  TaxTitle,
} from './styles';
import { CurrencyWrapper } from '../MapEditor/styles';

function MapDistances({ deliveryTypeChange, isTypeChanging }) {
  const { user, getProfileData } = useAuth();

  const [formatedAddress] = useState(() => {
    if (user.adress && user.adress.state) {
      const { number, street, neighborhood, city, state } = user.adress;

      const n = number < 0 ? 'N/A' : `Nº ${number}`;

      return `${street} ${n}, ${neighborhood}, ${city} - ${state}`;
    }

    return 'Não cadastrado.';
  });

  const [isDistanceByPath, setIsDistanceByPath] = useState(
    user.delivery_info?.is_distance_by_path || false
  );

  const [deliveryDistances, setDeliveryDistances] = useState([]);

  const [defaultDistance, setDefaultDistance] = useState(() => {
    return {
      key: v4(),
      distance: null,
      price: null,
      time: null,
      changed: false,
    };
  });

  const [center, setCenter] = useState([-20.3196699, -40.338479]);

  const changeDeliveryConfig = useCallback(async () => {
    try {
      await api2.put('/restaurants/delivery-info', {
        is_distance_by_path: !isDistanceByPath,
      });

      setIsDistanceByPath(!isDistanceByPath);
      getProfileData();

      toast.success('Atualizado');
    } catch (error) {
      toast.error('Erro ao atualizar perfil do restaurante');
    }
  }, [getProfileData, isDistanceByPath]);

  const fitZoom = useCallback(() => {
    const allLayers = [];

    L.mainMap.eachLayer((l) => {
      if (l instanceof L.Circle) {
        allLayers.push(l);
      }
    });

    if (allLayers.length) {
      const group = new L.FeatureGroup(allLayers);
      L.mainMap.fitBounds(group.getBounds());
    }
  }, []);

  const updateMap = useCallback(async () => {
    const translation = {
      zoom: {
        zoomInTitle: 'Aumentar o zoom do mapa',
        zoomOutTitle: 'Diminuir o zoom do mapa',
      },
    };

    let distances = [];
    let address = null;

    try {
      const { data } = await api2.get('/restaurants/delivery-areas');

      distances = data.distances;
      address = data.address;
    } catch (err) {
      console.error('Failed to load distances', err);
    }

    // TODO: Adicionar tratamento para restaurantes sem endereço
    const vitoria_centro = [-20.3196699, -40.338479];

    const map_center = address?.latitude
      ? [address.latitude, address.longitude]
      : vitoria_centro;

    const map = L.map('leaflet-map', {
      zoomControl: false,
    }).setView(map_center, 13);

    L.control.zoom(translation.zoom).addTo(map);

    L.mainMap = map;

    // L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   maxZoom: 19,
    //   attribution:
    //     '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    // }).addTo(map);

    L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution:
        '&copy; <a href="https://www.google.com/maps">Google Maps</a>',
    }).addTo(map);

    const pos = map_center;

    const icon = L.icon({
      iconUrl: '/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [-3, -76],
    });

    L.marker(pos, { icon, pmIgnore: true }).addTo(map);

    distances.forEach((d) => {
      d.key = v4();

      d.layer = new L.TipCircle(pos, {
        color: '#ff000099',
        fillColor: '#f5e4e7',
        fillOpacity: 0,
        radius: d.distance * 1000,
        dashArray: '30 10',
        pmIgnore: true,
      }).addTo(map);
    });

    fitZoom();
    setDeliveryDistances(distances);
    setCenter(pos);
  }, [fitZoom]);

  useEffect(() => {
    updateMap();
  }, [updateMap]);

  const handleValueChange = useCallback((e, field) => {
    // Extração segura do valor
    const value = e;

    setDefaultDistance((prev) => ({
      ...prev,
      [field]: value,
      changed: true,
    }));
  }, []);

  const handleAddDistance = useCallback(async () => {
    const data = {
      ...defaultDistance,
      price: defaultDistance.price,
      key: v4(),
    };

    console.log('@@ handleAddDistance', data);

    try {
      const response = await api2.post('/restaurants/delivery-distance', data);

      data.id = response.data.id;

      // Adicionando ao mapa
      if (L.mainMap) {
        data.layer = new L.TipCircle(center, {
          color: '#ff000099',
          fillColor: '#f03',
          fillOpacity: 0,
          dashArray: '30 10',
          radius: data.distance * 1000,
          pmIgnore: true,
        }).addTo(L.mainMap);

        fitZoom();
      }

      deliveryDistances.push(data);
      deliveryDistances.sort((a, b) => Number(a.distance) - Number(b.distance));

      setDeliveryDistances([...deliveryDistances]);

      setDefaultDistance({
        key: v4(),
        distance: null,
        price: null,
        type: null,
      });

      toast.success('Distância cadastrada');
    } catch (err) {
      console.log('@@ err', err);
      toast.error('Erro ao salvar distância');
    }
  }, [defaultDistance, deliveryDistances, center, fitZoom]);

  const handleDeleteDistance = useCallback(
    async (i) => {
      const dist = deliveryDistances[i];

      console.log('@@ handleDeleteDistance', dist);

      try {
        await api2.delete(`/restaurants/delivery-distance/${dist.id}`);

        // Removendo do mapa
        if (deliveryDistances[i].layer) {
          deliveryDistances[i].layer.remove();
        }

        deliveryDistances.splice(i, 1);
        setDeliveryDistances([...deliveryDistances]);

        toast.success('Distância apagada');
      } catch (err) {
        toast.error('Erro ao apagada distância');
      }
    },
    [deliveryDistances]
  );

  // Indica se algum dado foi alterado em caso positivo o botão é habilitado
  const [changed, setChanged] = useState([]);

  const saveEditedArea = useCallback(
    async (i) => {
      const { id, distance, time, price } = deliveryDistances[i];

      const data = { price, distance, time };

      try {
        await api2.put(`/restaurants/delivery-distance/${id}`, data);

        changed[i] = false;
        setChanged([...changed]);

        toast.success('Alterações salvas com sucesso!');
      } catch (e) {
        toast.error('Não foi possível salvar a alteração!');
      }
    },
    [deliveryDistances, changed]
  );

  const handleDistanceChange = useCallback(
    (e, i) => {
      const value =
        e?.floatValue !== undefined
          ? e.floatValue / 100
          : e?.target?.value ?? '';

      const updated = deliveryDistances.map((item, index) =>
        index === i ? { ...item, distance: value } : item
      );

      setDeliveryDistances(updated);

      if (!changed[i]) {
        const updatedChanged = [...changed];
        updatedChanged[i] = true;
        setChanged(updatedChanged);
      }
    },
    [deliveryDistances, changed, setDeliveryDistances]
  );

  const handlePriceChange = useCallback(
    (e, i) => {
      const value = e;

      const updated = deliveryDistances.map((item, index) =>
        index === i ? { ...item, price: value } : item
      );

      setDeliveryDistances(updated);

      if (!changed[i]) {
        const updatedChanged = [...changed];
        updatedChanged[i] = true;
        setChanged(updatedChanged);
      }
    },
    [deliveryDistances, changed, setDeliveryDistances]
  );

  const handleTimeChange = useCallback(
    (e, i) => {
      const value = e?.target?.value ?? '';

      const updated = deliveryDistances.map((item, index) =>
        index === i ? { ...item, time: value } : item
      );

      setDeliveryDistances(updated);

      if (!changed[i]) {
        const updatedChanged = [...changed];
        updatedChanged[i] = true;
        setChanged(updatedChanged);
      }
    },
    [deliveryDistances, changed, setDeliveryDistances]
  );

  const history = useHistory();

  const [extraTax, setExtraTax] = useState(
    user?.delivery_info?.extra_tax_per_km || 0
  );
  const [submittingExtraTax, setSubmitingExtraTax] = useState(false);

  const handleChangeExtraTax = useCallback(async () => {
    try {
      setSubmitingExtraTax(true);
      await api2.put('/restaurants/delivery-info', {
        extra_tax_per_km: extraTax,
      });
      setSubmitingExtraTax(false);
      toast.success('Taxa extra alterada com sucesso');
    } catch (e) {
      console.log(e);
      setSubmitingExtraTax(false);
      toast.error('Erro ao atualizar taxa extra');
    }
  }, [extraTax]);

  return (
    <Card>
      <Row>
        <TaxTitle>Taxa por Raio</TaxTitle>
      </Row>

      <Row style={{ margin: 0, height: '100%' }}>
        <Col md="6" style={{ padding: 0, paddingRight: 3 }}>
          <Map id="leaflet-map"> </Map>
        </Col>

        <Col md="6" style={{ height: '100%', padding: '0px 0px 0px 20px' }}>
          <Row>
            <Button
              variant="outlined"
              style={{
                background: '#fff',
                marginBottom: 10,
              }}
              icon={isTypeChanging ? <Spinner /> : <IconExchange />}
              onClick={() => deliveryTypeChange('map')}
            >
              Mudar para limitar por área
            </Button>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  marginBottom: '5px',
                  color: '#666666',
                }}
              >
                <b> Endereço: </b>
                <div style={{ marginLeft: '6px' }}> {formatedAddress} </div>
              </div>

              <Button
                icon={<IconPencilFilled />}
                onClick={() => history.push('/profile/info')}
                variant="outlined"
                style={{
                  background: '#fff',
                }}
              >
                Editar
              </Button>
              {/* <PenButton to={{ pathname: '/profile/info' }}>
                <FaPen size={16} />
              </PenButton> */}
            </div>
          </Row>

          <Divider
            color="#D9D9D9"
            style={{ marginTop: 8, border: '1px solid #D9D9D9' }}
          />
          <Row>
            <AddressesTable borderless>
              <thead>
                <tr>
                  <th> Alcance (km) </th>
                  <th> Taxa (R$) </th>
                  <th> Tempo (minutos) </th>
                  <th style={{ width: '60px' }}> </th>
                </tr>
              </thead>
              <tbody>
                <tr key={defaultDistance.key}>
                  <td>
                    <InputStyled
                      placeholder="Km..."
                      name="distance"
                      value={defaultDistance.distance}
                      onChange={(e) =>
                        handleValueChange(e.target.value, 'distance')
                      }
                    />
                  </td>
                  <td>
                    <CurrencyWrapper>
                      <BRLCurrencyInput
                        hasPrefix
                        isCurrency
                        name="value"
                        value={defaultDistance.price}
                        onChange={(e) => handleValueChange(e.value, 'price')}
                      />
                    </CurrencyWrapper>
                  </td>
                  <td>
                    <InputStyled
                      placeholder="Minutos..."
                      value={defaultDistance.time}
                      onChange={(e) =>
                        handleValueChange(e.target.value, 'time')
                      }
                    />
                  </td>
                  <td>
                    <PlusButton
                      disabled={!defaultDistance.changed}
                      onClick={() => handleAddDistance()}
                    >
                      <FaPlus />
                    </PlusButton>
                  </td>
                </tr>

                {deliveryDistances.map((item, i) => (
                  <tr key={item.key}>
                    <td>
                      <InputStyled
                        value={item.distance}
                        onChange={(e) => handleDistanceChange(e, i)}
                      />
                    </td>
                    <td>
                      <CurrencyWrapper>
                        <BRLCurrencyInput
                          hasPrefix
                          isCurrency
                          name="value"
                          value={item.price}
                          onChange={(e) => handlePriceChange(e.value, i)}
                        />
                      </CurrencyWrapper>
                    </td>
                    <td>
                      <InputStyled
                        value={item.time}
                        onChange={(e) => handleTimeChange(e, i)}
                      />
                    </td>
                    <td style={{ display: 'flex', alignItems: 'center' }}>
                      <PlusButton
                        disabled={!changed[i]}
                        onClick={() => saveEditedArea(i)}
                      >
                        <FaCheck />
                      </PlusButton>

                      <IconTrashFilled
                        onClick={() => handleDeleteDistance(i)}
                        fill="#C8131B"
                        style={{
                          fontSize: 24,
                          paddingLeft: 4,
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </AddressesTable>
          </Row>
          <Divider
            color="#D9D9D9"
            style={{
              marginTop: 8,
              marginBottom: 8,
              border: '1px solid #D9D9D9',
            }}
          />
          <Row>
            <Switch
              label="Considerar trajeto no cálculo da distância"
              id="delivery-path"
              checked={isDistanceByPath}
              onChange={() => changeDeliveryConfig()}
            />
          </Row>

          {isDistanceByPath && (
            <Row>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  alignItems: 'flex-end',
                  marginTop: 10,
                }}
              >
                <InputStyled
                  isCurrency
                  hasPrefix
                  label="Cobrança extra por km excedente no trajeto"
                  placeholder="R$ 0,00"
                  onChange={(e) => setExtraTax(e.target.value)}
                  containerStyles={{ background: '#f6f6f6' }}
                  style={{ background: '#fff' }}
                  value={extraTax}
                  disabled={false}
                />
                <PlusButton
                  disabled={extraTax < 0 || submittingExtraTax}
                  onClick={handleChangeExtraTax}
                >
                  {submittingExtraTax ? (
                    <Spinner color="#2EC9B7" style={{ width: 18 }} />
                  ) : (
                    <FaCheck />
                  )}
                </PlusButton>
              </div>
            </Row>
          )}
        </Col>
      </Row>
    </Card>
  );
}

export default MapDistances;
